import './styles.css';
import './i18n';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import i18n from './i18n';
import { App } from './App';
import { applyTheme, storedTheme } from './components/theme';

applyTheme(storedTheme());

const root = createRoot(document.getElementById('root')!);

function Splash({ text, error }: { text: string; error?: boolean }) {
  return (
    <div style={{ display: 'flex', minHeight: '100%', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ maxWidth: 520, textAlign: 'center', color: error ? 'var(--bad)' : 'var(--graphite)', fontSize: 14 }}>{text}</div>
    </div>
  );
}

async function boot() {
  if (__DEMO__) {
    const t = i18n.t.bind(i18n);
    root.render(<Splash text={t('app.loading')} />);
    try {
      const { startDemo } = await import('./lib/demo');
      await startDemo((step) => root.render(<Splash text={t(`app.loadingDemo.${step as 'db'}`)} />));
    } catch (e) {
      console.error(e);
      const wasm = typeof WebAssembly === 'undefined' || /wasm|WebAssembly|CompileError|Content Security/i.test(String(e));
      root.render(<Splash error text={wasm ? t('app.noWasm') : `${t('app.fatal')} ${String(e)}`} />);
      return;
    }
  }
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void boot();
